import { useMemo } from 'react';
import { Row } from '@tanstack/react-table';

import { Badge, BadgeColour } from '@xemplo/badge';
import { PayrunListItem, PayrunSteps } from '@xemplo/gp-types';
import { DawnTick } from '@xemplo/icons';

import {
  getCurrentMilestone,
  getDateDiffFromMilestone,
} from '../payrun-base-table.helper';

export const MilestoneBadgeCell = (props: Row<PayrunListItem>) => {
  const { original: payrun } = props;

  const activeStep = getCurrentMilestone(payrun);
  const { days, isPast } = getDateDiffFromMilestone(payrun);

  const badgeProps = useMemo(() => {
    const overdue = isPast;
    const dueSoon = !isPast && days < 7;
    if (activeStep === 'Draft')
      return { color: BadgeColour.LightGray, value: activeStep };
    if (activeStep === PayrunSteps.Complete)
      return {
        color: BadgeColour.LightGreen,
        value: 'Completed',
        leadingIcon: <DawnTick fontSize={16} />,
      };
    if (overdue) return { color: BadgeColour.LightRed, value: `${activeStep} overdue` };
    if (dueSoon) return { color: BadgeColour.LightOrange, value: `${activeStep} due` };
    return { color: BadgeColour.LightGray, value: activeStep ?? '' };
  }, [days, isPast, activeStep]);

  return <Badge {...badgeProps} />;
};
